import { InjectionToken } from '@angular/core';
import {
  AccountingCodeList,
  BuyerData,
  Cart,
  CartModification,
  Cutting,
  OrderCondition,
  OrderEntry,
  PrePrintedLabel,
  ReelCutting,
  TinyCart,
  Unit,
} from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util/converter.service';

export const ORDER_ENTRY_NORMALIZER = new InjectionToken<Converter<Occ.OrderEntry, OrderEntry>>('OrderEntryNormalizer');

export const CART_NORMALIZER = new InjectionToken<Converter<Occ.Cart, Cart>>('CartNormalizer');

export const BUYER_DATA_NORMALIZER = new InjectionToken<Converter<any, BuyerData>>('BuyerDataNormalizer');

export const CART_MODIFICATION_NORMALIZER = new InjectionToken<Converter<Occ.CartModification, CartModification>>(
  'CartModificationNormalizer'
);

export const TINY_CART_NORMALIZER = new InjectionToken<Converter<Occ.TinyCart, TinyCart>>('TinyCartNormalizer');

export const UNIT_NORMALIZER = new InjectionToken<Converter<Occ.Unit, Unit>>('UnitNormalizer');

export const CUTTING_NORMALIZER = new InjectionToken<Converter<Occ.Cutting, Cutting>>('CuttingNormalizer');

export const REEL_CUTTING_NORMALIZER = new InjectionToken<Converter<Occ.ReelCutting, ReelCutting>>('ReelCuttingNormalizer');

export const PRE_PRINTED_LABEL_NORMALIZER = new InjectionToken<Converter<Occ.PrePrintedLabel, PrePrintedLabel>>(
  'PrePrintedLabelNormalizer'
);

export const ORDER_CONDITION_NORMALIZER = new InjectionToken<Converter<Occ.SapOrderCondition, OrderCondition>>(
  'OrderConditionNormalizer'
);

export const ORDER_ENTRY_SERIALIZER = new InjectionToken<Converter<OrderEntry, Occ.ArticleLine>>('OrderEntrySerializer');

export const ACCOUNTING_CODE_LIST_NORMALIZER = new InjectionToken<Converter<Occ.AccountingCodeList, AccountingCodeList>>(
  'AccountingCodeListNormalizer'
);
